<template>
  <div
    class="shift"
    :class="[position]"
    v-if="
      (user.timeShift && user.timeShift[date]) ||
      positionCodeIsPicker ||
      !dayOff ||
      dayOff ||
      hasVacation
    "
  >
    <h2 class="shift__head">
      {{ dateTitle(date) }}
      <vita-icon
        name="cross"
        class="icon"
        @click="closeShifts($event)"
        data-qa="shift-control-icon-close"
      />
    </h2>
    <div>
      <div class="shift__content" v-if="!hasVacation">
        <template v-if="isUserInactive">
          <p>{{ inactiveReasonText }}</p>
        </template>
        <template v-if="!activeVacationChange">
          <div class="shift__form" v-if="canCreateShift() || hasVacationOnDay(user, date)">
            <!-- Отображаем создание смены в случае отсутствия кадровых на этот день -->
            <template v-if="!isUserInactive && canCreateShift() && !hasVacationOnDay(user, date)">
              <div class="shift__form-head">
                <p class="shift__title">Создать смену</p>
              </div>
              <div class="shift__inputs">
                <vita-input
                  :delete="false"
                  v-model="currentTimeFrom"
                  type="time"
                  icon="enter"
                  @input="inputEvent"
                  :disabled="!!updatingOpenId"
                  data-qa="shift-control-input-time-from"
                />
                <vita-input
                  :delete="false"
                  v-model="currentTimeTo"
                  type="time"
                  icon="exit"
                  @input="inputEvent"
                  :disabled="!!updatingOpenId"
                  data-qa="shift-control-input-time-to"
                />
                <vita-button
                  :disabled="!!updatingOpenId || inProcess || !!error"
                  width="inline"
                  @click="addShift"
                  data-qa="shift-control-button-add-shift"
                >
                  <vita-icon name="checked" />
                </vita-button>
                <vita-button
                  :class="{ 'not-available': !shiftBufferObj }"
                  width="inline"
                  color="orange"
                  @click="pasteShift(date)"
                  :disabled="!!updatingOpenId || inProcess"
                  :title="pasteShiftTitle"
                  data-qa="shift-control-button-paste-shift"
                >
                  <vita-icon name="duplicate" />
                </vita-button>
              </div>
              <div class="shift__times-break" v-if="dinerTime && !updatingOpenId">
                <vita-icon name="cup" class="icon" />
                <div>Перерыв:</div>
                <div>{{ dinerTime }}</div>
              </div>
              <div class="shift__error" v-if="error && !updatingOpenId">
                {{ error }}
              </div>
            </template>
            <!-- Отображаем список кадровых мероприятий согласно их типу вместо создания -->
            <div class="shift__vacation-row" v-if="!isUserInactive && hasVacationOnDay(user, date)">
              <div class="shift__vacation-title">
                <VitaVacationItem
                  v-for="(item, idx) in dayVacations"
                  :key="idx"
                  :vacation="item"
                  :zupGuid="user.zupGuid"
                  :userCanEdit="canCreateVacation(user, date)"
                  v-model:visible="activeVacationChange"
                  v-model:visibleUpdate="activeVacationUpdate"
                />
              </div>
            </div>
          </div>
          <template v-if="!canCreateShift()">
            <!-- Нельзя создать смену -->
            <div v-if="isExternalProfiUser" class="shift__error-wrap">
              <p class="shift__error shift__error-secondary">
                Создание смен для данного сотрудника доступно только в аптеке, где он трудоустроен
              </p>
            </div>
            <template
              v-else-if="!isOfflineDirectorRole && !isWFMReaderRole && !props.isUserInactive"
            >
              <div v-if="pastDayError" class="shift__error-wrap">
                <p class="shift__error">Невозможно создать смену на прошедший день.</p>
              </div>
              <div v-else-if="scheduleError" class="shift__error-wrap">
                <p class="shift__error">Отсутствует расписание аптеки</p>
              </div>
              <div v-else-if="dayOffError" class="shift__error-wrap">
                <p class="shift__error">Невозможно создать смену. В аптеке выходной день.</p>
              </div>
            </template>
          </template>
          <!-- Отображение кнопки создания НН -->
          <div
            class="shift__vacation-add"
            v-if="!hasAbsenceOnDay(user, date) && canCreateVacation(user, date)"
          >
            <button
              class="shift__link"
              type="button"
              @click="openVacationEdit"
              :disabled="inProcess"
              data-qa="shift-control-button-vacation-add"
            >
              <span>Проставить НН</span>
              <vita-icon name="chevron-right" />
            </button>
          </div>
          <div class="shift__times" v-if="user.timeShift && isShiftsVisible(user, date)">
            <p class="shift__title">Назначенные смены</p>
            <PerfectScrollbar
              ref="shiftsScrollList"
              class="scroll-comment rail-thin shift__times-wrap"
              :id="!isScrollable && !inProcess ? 'no-scroll' : null"
              :options="{ wheelPropagation: false, suppressScrollX: true }"
            >
              <div
                class="shift__times-item"
                :class="shiftTimesType(item)"
                v-for="item in user.timeShift[date]"
                :key="item.dateFrom"
                :data-editable="isUpdateShiftAvailable(item)"
              >
                <div class="shift__times-date" v-if="isCrossingShift(item)">
                  <span>({{ item.dateFrom }} </span><vita-icon name="arrow" /><span
                    >{{ item.dateTo }})</span
                  >
                </div>
                <div class="shift__times-time">
                  <div>
                    <vita-icon class="icon" name="watch" />
                  </div>
                  <div
                    class="shift__times-time-inner"
                    :class="{ 'update-active-span': updatingOpenId && updatingOpenId === item.id }"
                  >
                    <div
                      class="time-wrapper"
                      @click="onUpdateShiftClick(item)"
                      :class="{ 'update-active': updatingOpenId && updatingOpenId === item.id }"
                      data-qa="shift-control-time-open-edit"
                    >
                      <div class="time">
                        <div
                          class="editing-fields"
                          v-if="updatingOpenId && updatingOpenId === item.id"
                        >
                          <vita-input
                            secondaryStyle="true"
                            :delete="false"
                            v-model="timeFrom"
                            :value="timeFrom"
                            type="time"
                            @input="inputEvent()"
                            :readonly="item.status === 'Active'"
                            :disabled="item.status === 'Active'"
                            data-qa="shift-control-input-edit-time-from"
                          />
                          <vita-icon class="icon-arrow" name="arrow" />
                          <vita-input
                            secondaryStyle="true"
                            :delete="false"
                            v-model="timeTo"
                            :value="timeTo"
                            type="time"
                            @input="inputEvent()"
                            data-qa="shift-control-input-edit-time-to"
                          />
                        </div>
                        <div class="editing-fields" v-else>
                          <span>
                            {{ item.timeFrom }}
                          </span>
                          <vita-icon class="icon-arrow" name="arrow" />
                          <span>
                            {{ item.timeTo }}
                          </span>
                        </div>
                      </div>
                      <div class="d-flex" v-if="updatingOpenId && updatingOpenId === item.id">
                        <button
                          class="button btn-success"
                          type="button"
                          @click.stop="updateShift()"
                          :disabled="inProcess || !!error"
                          data-qa="shift-control-button-update-shift"
                        >
                          <vita-icon name="checked" />
                        </button>
                      </div>
                    </div>

                    <div class="shift__times-item-close">
                      <div v-if="updatingOpenId && updatingOpenId === item.id">
                        <div
                          @click="closeUpdatingItem()"
                          class="d-flex close"
                          data-qa="shift-control-icon-edit-cancel"
                        >
                          <vita-icon name="cross-dark" />
                        </div>
                      </div>
                    </div>

                    <div
                      class="shift__menu"
                      v-if="canOpenShiftMenu(item)"
                      v-click-outside-element="() => closeShiftMenu(item)"
                    >
                      <div
                        @click="openShiftMenu(item)"
                        class="shift__menu-icon"
                        v-if="!isWFMReaderRole && item.zupGuid"
                        data-qa="shift-control-icon-menu-open"
                      >
                        <vita-icon name="kebab-menu" />
                      </div>
                      <VitaShiftMenuDialog
                        v-if="menuOpenId === item.id"
                        :position="position"
                        :can-delete="isDeleteShiftAvailable(item)"
                        :can-update="isUpdateShiftAvailable(item)"
                        :can-copy="Boolean(isCopyShiftAvailable(item))"
                        :can-info="Boolean(isInfoShiftAvailable(item))"
                        :disabled="inProcess"
                        @delete="openDeleteModal(item)"
                        @update="onUpdateShiftClick(item)"
                        @copy="onCopyShiftClick(item)"
                        @info="onInfoShiftClick(item)"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="shift__times-break"
                  v-if="
                    (item.diner && !updatingOpenId) ||
                    (item.diner && updatingOpenId && updatingOpenId !== item.id)
                  "
                >
                  <vita-icon name="cup" class="icon" />
                  <div>Перерыв:</div>
                  <div>{{ item.diner }}</div>
                </div>
                <div
                  class="shift__times-break"
                  v-else-if="dinerTime && updatingOpenId && updatingOpenId === item.id"
                >
                  <vita-icon name="cup" class="icon" />
                  <div>Перерыв:</div>
                  <div>{{ dinerTime }}</div>
                </div>
                <div
                  class="shift__error shift__error-secondary"
                  v-if="error && updatingOpenId && updatingOpenId === item.id"
                >
                  {{ error }}
                </div>
                <div v-if="user.timeShift && item.status === 'Miss'">
                  <button
                    class="button btn-toggle"
                    :class="{ 'btn-toggle-open': openedMissSpoiler }"
                    type="button"
                    @click="openMissSpoiler(item)"
                    data-qa="shift-control-button-miss-toggle"
                  >
                    <span>Сотрудник уведомил о невыходе</span>
                    <vita-icon name="chevron-down" />
                  </button>
                  <div class="shift-miss-layout" v-if="openedMissSpoiler">
                    <div class="shift-miss-layout-inner">
                      <div v-if="user.timeShift[date][0].cancelationReason">
                        <div>Причина</div>
                        <div>{{ user.timeShift[date][0].cancelationReason }}</div>
                      </div>
                      <div v-if="user.timeShift[date][0].cancelationComment">
                        <div>Комментарий</div>
                        <perfect-scrollbar
                          class="scroll-comment"
                          :options="{ wheelPropagation: false, suppressScrollX: true }"
                        >
                          <div class="shift-miss-layout-comment">
                            {{ user.timeShift[date][0].cancelationComment }}
                          </div>
                        </perfect-scrollbar>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </PerfectScrollbar>
          </div>
        </template>
        <template v-else>
          <VitaVacationControl
            :date="date"
            :zup-guid="user.zupGuid"
            :timezone-offset="timezoneOffset"
            :pharm-id="pharmId"
            :update-id="activeVacationUpdate"
            v-model:visible="activeVacationChange"
          />
        </template>
      </div>
      <vita-icon class="shift__tri" name="tri" />
    </div>
    <div v-if="text">
      <div class="shift__content">
        {{ text }}
      </div>
    </div>
  </div>
  <vita-info-modal
    :open="shiftInfoModal.open"
    @toggleInfoModal="closeShiftInfoModal"
    title="Информация о смене"
    modal-icon="pencil-edit"
    modal-size="medium-wide"
  >
    <vita-shift-info :shift-id="shiftInfoId" :timeShift="user.timeShift && user.timeShift[date]" />
  </vita-info-modal>
  <vita-modal v-if="openModal" title="Вы действительно хотите удалить смену?">
    <vita-button
      color="red"
      width="inline"
      @click="deleteShift($event)"
      :disabled="inProcess"
      data-qa="shift-control-button-delete-confirm"
      >Да</vita-button
    >
    <vita-button
      color="blue"
      width="inline"
      @click="onShiftDeleteCancel"
      :disabled="inProcess"
      data-qa="shift-control-button-delete-cancel"
      >Нет</vita-button
    >
  </vita-modal>
  <vita-modal v-if="openConfirmModal" title="Вы уверены, что хотите отменить проставление НН?">
    <vita-button
      color="red"
      width="inline"
      @click="closeVacationEdit"
      :disabled="inProcess"
      data-qa="shift-control-button-vacation-cancel-confirm"
      >Да</vita-button
    >
    <vita-button
      color="blue"
      width="inline"
      @click="openConfirmModal = false"
      :disabled="inProcess"
      data-qa="shift-control-button-vacation-cancel-reject"
      >Нет</vita-button
    >
  </vita-modal>
</template>

<script lang="ts" setup>
import { computed, nextTick, onBeforeMount, onBeforeUnmount, onMounted, ref } from 'vue'
import {
  addDays,
  addHours,
  addMonths,
  differenceInCalendarMonths,
  format,
  isBefore,
  isLastDayOfMonth,
  parse,
  startOfDay,
  startOfMonth,
  startOfToday,
} from 'date-fns'
import { ru } from 'date-fns/locale'
import {
  ErrorResponseData,
  FrvQuery,
  MainShift,
  NewUser,
  TimeRange,
  TimeShiftQuery,
  UpdatingShift,
  VacationItem,
} from '@/types'
import { useStore } from 'vuex'
import { dinerCalculation, frvCore } from '@/utils/frv'
import { extractDatePartsGURV } from '@/utils/gurv'
import { v4 as uuid } from 'uuid'
import { checkUnsavedChanges, frvTypeList } from '@/utils/main'
import VitaInfoModal from '@/components/UI/VitaInfoModal.vue'
import VitaShiftInfo from '@/components/VitaShiftInfo.vue'
import { PerfectScrollbar, PerfectScrollbarExpose } from 'vue3-perfect-scrollbar'
import VitaButton from '@/components/UI/VitaButton.vue'
import VitaInput from '@/components/UI/VitaInput.vue'
import VitaVacationControl from '@/components/ShiftControl/VitaVacationControl.vue'
import VitaShiftMenuDialog from '@/components/ShiftControl/VitaShiftMenuDialog.vue'
import VitaIcon from '@/components/UI/VitaIcon.vue'
import VitaVacationItem from '@/components/VitaVacationItem.vue'
import { AxiosError } from 'axios'
import { showRequestErrorToast } from '@/utils/toast'
import { reachGoal } from '@/utils/metrika'

interface Props {
  date: string
  position: string
  user: NewUser
  text?: string
  hasVacation?: object | boolean
  showCreate?: boolean
  isUserInactive?: boolean
}

const store = useStore()

// Есть ли у пользователя роль GURV
const isGurvRole = computed<boolean>(() => {
  return store.getters['getGurvRole']
})

// Есть ли у пользователя роль OFFLINE_DIRECTOR
const isOfflineDirectorRole = computed<boolean>(() => {
  return store.getters['getOfflineDirectorRole']
})

// Есть ли у пользователя роль WFM_READER
const isWFMReaderRole = computed<boolean>(() => {
  return store.getters['getWFMReaderRole']
})

// Есть ли у пользователя роль OFFLINE_ADMIN
const isOfflineAdminRole = computed<boolean>(() => {
  return store.getters['getOfflineAdminRole']
})

const dayOff = computed<boolean>(() => {
  return !store.getters['data/timeSchedule'][props.date].actualWorkTime
})

// Расписание отсутствует, день создан на фронте
const dayScheduleEmpty = computed<boolean>(() => {
  return store.getters['data/timeSchedule'][props.date].emptySchedule
})

const props = withDefaults(defineProps<Props>(), {
  date: '',
  position: 'top right',
})

const timeSchedule = computed<string>(() => {
  return store.getters['data/timeSchedule'][props.date].actualWorkTime || '00:00-24:00'
})
const pharmId = computed<number>(() => {
  return store.getters['data/pharmId']
})
const timezoneOffset = computed<number>(() => {
  return Math.abs(new Date().getTimezoneOffset() / 60)
})

const scheduleActualWorkTime = computed<string>(() => {
  return store.getters['data/timeSchedule'][props.date].actualWorkTime
})

const shiftBufferObj = computed<null | TimeRange>(() => {
  return store.getters['getShiftBuffer']
})

const nextDate = computed<string>(() => {
  return `${nextDay} ${timeTo.value}`
})
const startTime = timeSchedule.value?.split('-')[0]
const endTime = timeSchedule.value?.split('-')[1]
const currentDay = parse(props.date, 'dd.M.yyyy', new Date())
const nextDay = format(addDays(currentDay, 1), 'dd.M.yyyy')
const formattedNextDay = format(addDays(currentDay, 1), 'd.M.yyyy')
const openModal = ref<boolean>(false)
const openConfirmModal = ref<boolean>(false)
const error = ref<string>('')
const shiftItem = ref<TimeRange>()
const missShiftItem = ref<TimeRange>()
const openedMissSpoiler = ref<boolean>(false)
const newShift = ref<boolean>(
  addDays(new Date(), -3).getTime() < parse(props.date, 'd.M.yyyy', new Date()).getTime(),
)
const updatingOpenId = ref<null | string>('')
const menuOpenId = ref<null | string>('')
let timeFrom = ref<string>(startTime)
const timeFromStatic = ref<string>('00:00')
let timeTo = ref<string>(endTime)
const timeToStatic = ref<string>('00:00')
const dinerTime = ref<string>('')
const timeFRVDiff = ref<FrvQuery>({ frv: 0, frvRV: 0 })
const frvCalcQuery = ref<FrvQuery>({ frv: 0, frvRV: 0 })
const shiftBuffer = ref({})

// Для ПрофиПСТ отдельный тип смены при создании
const shiftType = computed<string>(() => props.user.profiPstUser ? "MainProfi" : "Main");

// ПрофиПСТ попавший в список из смен api/admin-shift (setExternalUsers) - трудоустроен в другой аптеке
const isExternalProfiUser = computed<boolean>(() => props.user.profiPstUser && props.user.externalUser);

const shifts = ref<MainShift>({
  pharmId: pharmId.value,
  zupGuid: props.user.zupGuid,
  userId: props.user.id,
  dateFrom: '',
  dateTo: '',
  shiftStatus: 'New',
  shiftType: shiftType.value,
  tempId: uuid(),
})

const originShiftTimeRange = ref<TimeRange>({
  big: false,
  dateFrom: '',
  dateTo: '',
  diner: null,
  id: '',
  passed: false,
  status: '',
  timeFrom: '',
  timeTo: '',
  type: '',
  zupGuid: '',
  timeZone: 0,
  cancelationReason: '',
  cancelationComment: '',
})

const activeVacationChange = ref(false)
const activeVacationUpdate = ref<string | null>(null)

// Кадровые мероприятия дня лежат вложенным массивом в первом элементе timeShift (см. setAdminShift)
const dayVacations = computed<VacationItem[]>(() => {
  const first = props.user.timeShift?.[props.date]?.[0]
  return Array.isArray(first) ? (first as unknown as VacationItem[]) : []
})

// Логика "Только просмотр" и "Редактирование" в зависимости от состояния переменной updatingOpenId
const currentTimeFrom = computed({
  get: () => (updatingOpenId.value ? timeFromStatic.value : timeFrom.value),
  set: (val: string) => {
    if (!updatingOpenId.value) {
      timeFrom.value = val
    }
  },
})

const currentTimeTo = computed({
  get: () => (updatingOpenId.value ? timeToStatic.value : timeTo.value),
  set: (val: string) => {
    if (!updatingOpenId.value) {
      timeTo.value = val
    }
  },
})

// получаем дату в формате dd.M.yyyy и возвращаем true если это праздник
const isHoliday = computed<boolean>(() => {
  return store.getters['data/holidays'] && store.getters['data/holidays'].includes(props.date)
})

const timeShiftQuery: TimeShiftQuery = {
  timeShift: 0,
  zupGuid: props.user.zupGuid,
  timeShiftNoDiner: 0,
  timeShiftFull: 0,
  holiday: isHoliday.value,
  frvRv: 0,
  dinners: {
    first: {
      startTime: 0,
      endTime: 0,
      duration: 0,
      durationMinutes: 0,
    },
    second: {
      startTime: 0,
      endTime: 0,
      duration: 0,
      durationMinutes: 0,
    },
  },
}

const inProcess = ref<boolean>(false)
const shiftInfoModal = ref({ open: false })

const getPharmacies = async () => {
  await store.dispatch('data/getFondWorkTime')
  await store.dispatch('data/getAdminShift')
  // Обновление расписания для незаполненных дней
  await store.dispatch('data/getTimeScheduleDetails')
  await store.dispatch('data/getTimeSchedule')
  // noinspection ES6MissingAwait
  store.dispatch('data/getFondWorkTimeHuman')
}
const dateTitle = (date: string): string => {
  const formattedDate = format(
    parse(date, 'dd.MM.yyyy', new Date(), { locale: ru }),
    'd MMMM yyyy, EEEE',
    { locale: ru },
  )
  const dayOfWeek = formattedDate.split(',')[1].trim()
  const capitalizedDayOfWeek = dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1)

  return formattedDate.replace(dayOfWeek, capitalizedDayOfWeek)
}
const openDeleteModal = (item: TimeRange) => {
  closeShiftMenu(item)
  openModal.value = true
  shiftItem.value = item
  reachGoal('timetable-shift-delete')
}

const deleteShift = async (e: Event) => {
  e.stopPropagation()
  closeUpdatingItem()

  try {
    inProcess.value = true
    await store.dispatch('data/deleteShift', shiftItem.value)

    await getPharmacies()
    if ((positionCodeIsPicker.value && dayOff.value) || (!dayOff.value && !props.hasVacation)) {
      store.commit('data/saveMainFRV')
      store.commit('data/saveHumanFRV', props.user)
      store.commit('data/changeTimeShift', timeShiftQuery)
      store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)
    }
    store.commit('data/closeCreateShift') // Закрываем окно создание смен после удаления смены (OMR-3256)
    checkUnsavedChanges()
    reachGoal('timetable-shift-delete-confirm')
  } catch (e) {
    const err = e as AxiosError<ErrorResponseData>
    if (err.response && localStorage.getItem('token')) showRequestErrorToast(err)
  } finally {
    inProcess.value = false
    openModal.value = false
  }
}

const onShiftDeleteCancel = () => {
  openModal.value = false
  reachGoal('timetable-shift-delete-cancel')
}

const shiftTimesType = (item: TimeRange) => {
  if (!item.zupGuid) {
    return 'not-shift'
  }
  const classArr: string[] = []
  classArr.push(`shift__times-${item.status.toLowerCase()}`)

  if ((!positionCodeIsPicker.value && dayOff.value) || dayScheduleEmpty.value) {
    classArr.push('shift__times-dayoff')
  }

  if (!isGurvRole.value) {
    classArr.push('shift__times-hidden')
  }

  if (item.type === 'Exchange') {
    classArr.push('shift__times-exchange')
  }

  if (!canUpdateShift(item)) {
    classArr.push('shift__times-default')
  }

  return classArr.join(' ')
}

// Принимаем строку со временем в формате 00:00 и отдаём количество секунд
const timeToSeconds = (time: string): number => {
  const hours: number = +time.split(':')[0]
  const minutes: number = +time.split(':')[1]
  return (hours * 60 + minutes) * 60
}

// Принимаем количество секунд и отдаём строку в формате 00:00
const secondsToTime = (second: number): string => {
  const hours = Math.floor(second / 60 / 60)
  const minutes = Math.floor(second / 60) - hours * 60
  const minutesString = minutes.toString().length > 1 ? minutes : '0' + minutes
  return `${hours}:${minutesString}`
}

const isLastDay = isLastDayOfMonth(currentDay)

// Расчёт обедов и длительности смены
const updateDinerTime = () => {
  dinerTime.value = dinerCalculation(
    timeShiftQuery,
    timeFrom,
    timeTo,
    currentDay,
    props.user.timeZone,
  )
}

const removeDinnerTime = () => {
  if (!updatingOpenId.value) dinerTime.value = ''
}

// Попадает ли время в рабочие часы аптеки
const isWithinWorkingHours = (from: string, to: string, start: string, end: string) => {
  return timeToSeconds(from) >= timeToSeconds(start) && timeToSeconds(to) <= timeToSeconds(end)
}

//
const inputEvent = () => {
  // Проверка на NaN при вводе в input
  if (timeFrom.value == '' || timeTo.value == '') {
    timeShiftQuery.timeShift = 0
    timeShiftQuery.frvRv = 0
    error.value = 'Введите время начала и завершения смены'

    store.commit('data/changeTimeShift', timeShiftQuery)
    store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)
    return false
  }

  updateDinerTime()

  try {
    if (timeShiftQuery.timeShiftNoDiner > 15) {
      error.value = 'Длительность смены превышает 15 часов'
      removeDinnerTime()
    } else if (
      !positionCodeIsPicker.value &&
      !isWithinWorkingHours(timeFrom.value, timeTo.value, startTime, endTime)
    ) {
      error.value = 'Аптека в это время закрыта'
      removeDinnerTime()
    } else {
      error.value = ''
      shifts.value.dateFrom = addHours(
        parse(`${props.date} ${timeFrom.value}`, 'd.M.yyyy HH:mm', new Date()),
        timezoneOffset.value,
      ).toISOString()
      if (timeToSeconds(timeTo.value) < timeToSeconds(timeFrom.value)) {
        shifts.value.dateTo = addHours(
          parse(nextDate.value, 'd.M.yyyy HH:mm', new Date()),
          timezoneOffset.value,
        ).toISOString()
      } else {
        if (timeTo.value === '24:00') {
          timeTo.value = '00:00'
          shifts.value.dateTo = addHours(
            parse(nextDate.value, 'd.M.yyyy HH:mm', new Date()),
            timezoneOffset.value,
          ).toISOString()
        } else {
          shifts.value.dateTo = addHours(
            parse(`${props.date} ${timeTo.value}`, 'd.M.yyyy HH:mm', new Date()),
            timezoneOffset.value,
          ).toISOString()
        }
      }
    }

    if (updatingOpenId.value) {
      // Активно редактирование смены
      const todayDateTimeISO = new Date().toISOString()
      const realTodayDateTimeISO = addHours(
        new Date(todayDateTimeISO),
        props.user.timeZone,
      ).toISOString()
      const shiftStatus = originShiftTimeRange.value.status

      if (shiftStatus !== 'Active' && realTodayDateTimeISO > shifts.value.dateFrom) {
        error.value =
          'Невозможно внести изменения, так как начало смены не может быть установлено раньше, чем текущее время'
        !updatingOpenId.value ? (dinerTime.value = '') : null
      }

      if (!error.value && shifts.value.dateTo < realTodayDateTimeISO) {
        error.value =
          'Невозможно внести изменения, так как окончание смены не может быть установлено раньше, чем текущее время'
        !updatingOpenId.value ? (dinerTime.value = '') : null
      }
    }

    // Переходящие смены в круглосуточных (и не очень) днях
    if (!positionCodeIsPicker.value && timeShiftQuery.timeShiftNoDiner <= 15) {
      if (!scheduleActualWorkTime.value) return // Не применяем в выходной день

      // Не применяем в последнем дне месяца или перед днём БЕЗ РАСПИСАНИЯ (OMR-2966)
      if (scheduleNextDayWorkTime.value === '00:00-00:00') return

      // Запрещаем создавать переходящие смены в нерабочие часы следующего дня
      if (scheduleNextDayWorkTime.value) {
        if (
          timeToSeconds(timeFrom.value) > timeToSeconds(timeTo.value) &&
          timeToSeconds(timeTo.value) > timeToSeconds(scheduleNextDayWorkTime.value.split('-')[1])
        ) {
          error.value = 'Аптека в это время закрыта'
          removeDinnerTime()
          return false
        }

        // Проверяем последнюю часть времени текущего дня и первую часть следующего дня
        if (
          scheduleActualWorkTime.value.split('-')[1] === '24:00' &&
          scheduleNextDayWorkTime.value.split('-')[0] === '00:00'
        ) {
          error.value = ''
        } else {
          if (
            scheduleActualWorkTime.value !== '00:00-24:00' &&
            timeToSeconds(timeFrom.value) > timeToSeconds(timeTo.value)
          ) {
            error.value = 'Аптека в это время закрыта'
            removeDinnerTime()
          }

          if (scheduleNextDayWorkTime.value !== '00:00-24:00') {
            if (
              timeToSeconds(timeFrom.value) > timeToSeconds(timeTo.value) &&
              timeTo.value !== '00:00'
            ) {
              error.value = 'Аптека в это время закрыта'
              removeDinnerTime()
            }
          }
        }
      }
    }

    if (updatingOpenId.value) {
      updatedShift.value.dateFrom = shifts.value.dateFrom
      updatedShift.value.dateTo = shifts.value.dateTo
    }
  } catch (e) {
    console.error(e)
    error.value = 'Введите время начала и завершения смены'
  }

  frvCalcQuery.value = frvCore(timeShiftQuery, isLastDay, isHoliday, shifts, timeFrom, timeTo)
  timeShiftQuery.timeShift = frvCalcQuery.value.frv
  timeShiftQuery.frvRv = frvCalcQuery.value.frvRV

  if ((positionCodeIsPicker.value && dayOff.value) || (!dayOff.value && !props.hasVacation)) {
    store.commit('data/changeTimeShift', timeShiftQuery)
    store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)
  }
}

const setValidInputTime = () => {
  if (timeToSeconds(timeTo.value) - timeToSeconds(timeFrom.value) > timeToSeconds('15:00')) {
    timeTo.value = secondsToTime(timeToSeconds(timeFrom.value) + timeToSeconds('15:00'))
  }

  if (props.user.grade === 10 && timeToSeconds(startTime) < timeToSeconds('06:00')) {
    timeFrom.value = '06:00'
  }
}

const addShift = async () => {
  inProcess.value = true

  shifts.value.shiftType = shiftType.value
  const { statusCode } = await store.dispatch('data/addShift', shifts.value)
  if (statusCode >= 400) {
    inProcess.value = false
    return
  }

  // noinspection ES6MissingAwait
  store.dispatch('data/getFondWorkTime')
  // noinspection ES6MissingAwait
  store.dispatch('data/getFondWorkTimeHuman')
  await store.dispatch('data/getPharmSchedule')
  await store.dispatch('data/getAdminShift')
  // Обновление расписания для незаполненных дней
  await store.dispatch('data/getTimeScheduleDetails')
  await store.dispatch('data/getTimeSchedule')
  // Обновляем ФРВ после создания смены (OMR-3583)
  store.commit('data/changeTimeShift', timeShiftQuery)
  store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)

  inProcess.value = false
  checkUnsavedChanges()
  // Проверяем высоту списка смен при создании (OMR-3896)
  await checkShiftsHeight()
  reachGoal('timetable-create-shift')
}

const closeShifts = (e: MouseEvent) => {
  e.stopPropagation()
  if (updatingOpenId.value) {
    store.commit('data/resetMainFRV')
    store.commit('data/resetHumanFRV', { user: props.user })
  }

  if (activeVacationChange.value) {
    openConfirmModal.value = true
    return false
  }
  store.commit('data/closeCreateShift')
}

const updateFRVquery = () => {
  store.commit('data/changeTimeShift', timeShiftQuery)
  store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)
}

const scheduleNextDayWorkTime = computed<string>(() => {
  if (store.getters['data/timeSchedule'][formattedNextDay]) {
    return store.getters['data/timeSchedule'][formattedNextDay].actualWorkTime
  }
  return false
})

const updatedShift = ref<UpdatingShift>({
  id: null,
  dateFrom: '',
  dateTo: '',
  tempId: uuid(),
})

// Восстановление состояния инпутов для обновления смены
const restoreInputsState = () => {
  timeFrom = ref<string>(startTime)
  timeTo = ref<string>(endTime)
  error.value = ''
  setValidInputTime()
  updateDinerTime()

  // Убрано обновление ФРВ из-за неверного пересчета (OMR-3039)
}

// Проверка на возможность пересчёта планового ФРВ аптеки по смене
const canChangePharmFRV = (item: TimeRange) => {
  // У уборщиков, дворников и заведующих основной ФРВ не меняется
  const isEditableGrade = props.user.grade !== 10

  // Сотрудники и смены ПрофиПСТ в ФРВ аптеки не входят
  const isNotProfi = !props.user.profiPstUser && item.type !== 'MainProfi'

  // Типы ФРВ, у которых разрешено изменение (включая сотрудников из других аптек)
  const isEditableFrvType = Boolean(
    props.user.frv?.frvType && frvTypeList.includes(props.user.frv.frvType),
  )

  return isEditableGrade && isNotProfi && isEditableFrvType
}

// Открыто обновление смены
const openUpdatingItem = (item: TimeRange) => {
  if (updatingOpenId.value) {
    closeUpdatingItem()
  }
  error.value = ''
  store.commit('data/saveMainFRV')
  store.commit('data/saveHumanFRV', props.user) // Сохраняем humanFRV для перерасчёта при закрытии (OMR-3583)
  originShiftTimeRange.value = item

  // Устанавливаем время редактируемой смены
  timeFrom = ref<string>(item.timeFrom)
  timeTo = ref<string>(item.timeTo)

  timeShiftQuery.timeShift = 0
  timeShiftQuery.frvRv = 0

  store.commit('data/changeTimeShift', timeShiftQuery)
  store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)

  updateDinerTime()

  timeFRVDiff.value = frvCore(timeShiftQuery, isLastDay, isHoliday, shifts, timeFrom, timeTo)

  timeShiftQuery.timeShift = timeFRVDiff.value.frv
  timeShiftQuery.frvRv = timeFRVDiff.value.frvRV

  store.commit('data/changeTimeShift', timeShiftQuery)
  store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)

  if (canChangePharmFRV(item)) {
    store.commit('data/changeMainFRV', {
      frv: timeFRVDiff.value.frv,
      frvRV: timeFRVDiff.value.frvRV,
    })
  }

  store.commit('data/changeHumanFRV', {
    frv: timeFRVDiff.value.frv,
    frvRV: timeFRVDiff.value.frvRV,
    user: props.user,
  })

  // Добавляем ID смены и текущее время (переводя в ISO формат) в объект для обновления
  updatedShift.value.id = item.id
  updatedShift.value.dateFrom = addHours(
    parse(
      `${originShiftTimeRange.value.dateFrom} ${originShiftTimeRange.value.timeFrom}`,
      'd.M.yyyy HH:mm',
      new Date(),
    ),
    timezoneOffset.value,
  ).toISOString()
  updatedShift.value.dateTo = addHours(
    parse(
      `${originShiftTimeRange.value.dateTo} ${originShiftTimeRange.value.timeTo}`,
      'd.M.yyyy HH:mm',
      new Date(),
    ),
    timezoneOffset.value,
  ).toISOString()

  // Устанавливаем статус - активно редактирование для элемента
  updatingOpenId.value = item.id
}

const closeUpdatingItem = () => {
  store.commit('data/resetMainFRV')
  store.commit('data/resetHumanFRV', { user: props.user })
  timeFrom = ref<string>(startTime)
  timeTo = ref<string>(endTime)
  error.value = ''
  updatingOpenId.value = null
  setValidInputTime()
  if (newShift.value) {
    inputEvent()
  }
  if ((positionCodeIsPicker.value && dayOff.value) || (!dayOff.value && !props.hasVacation)) {
    store.commit('data/changeTimeShift', timeShiftQuery)
    store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)
  }
}

const updateShift = async () => {
  inProcess.value = true

  try {
    await store.dispatch('data/updateShift', updatedShift.value)
    await getPharmacies()
    if ((positionCodeIsPicker.value && dayOff.value) || (!dayOff.value && !props.hasVacation)) {
      updateFRVquery()
    }
    updatingOpenId.value = null
    restoreInputsState()
    store.commit('data/saveHumanFRV', props.user)
    store.commit('data/closeCreateShift')
  } catch (e) {
    const err = e as AxiosError<ErrorResponseData>
    if (err.response && localStorage.getItem('token')) showRequestErrorToast(err)
  } finally {
    inProcess.value = false
  }
}

const isCrossingShift = (item: TimeRange) => {
  const isTomorrowDay = timeTo.value <= timeFrom.value
  const tomorrowDate = addDays(
    addHours(parse(props.date, 'd.M.yyyy', new Date()), timezoneOffset.value),
    1,
  )
  if (item.big && updatingOpenId.value !== item.id) {
    item.dateTo = format(tomorrowDate, 'd.M.yyyy')
    return true
  }
  if (timeTo.value === timeFrom.value) {
    return false
  }
  if ((item.big || (item.timeTo <= item.timeFrom && isLastDay)) && !updatingOpenId.value) {
    return true
  } else if (isTomorrowDay && updatingOpenId.value && updatingOpenId.value === item.id) {
    item.dateTo = format(tomorrowDate, 'd.M.yyyy')
    return true
  } else {
    return false
  }
}

const openMissSpoiler = (item: TimeRange) => {
  openedMissSpoiler.value = !openedMissSpoiler.value
  missShiftItem.value = item
  checkShiftsHeight()
}

const canUpdateShift = (item: TimeRange) => {
  const { creatingDay, creatingMonth, currentMonthNumber, previousMonthNumber, currentDay } =
    extractDatePartsGURV(props.date)

  const isNotExchange = item.type !== 'Exchange';
  const isNotProfiPst = item.type !== 'ProfiPst';
  const isNotMiss = item.status !== 'Miss';
  const isNotMissAccepted = item.status !== 'MissAccepted';
  const isNotCanceled = item.status !== 'Canceled';
  const isDone = item.status === 'Done';
  const isPositionOrActiveOrNew = positionCodeIsPicker.value || item.status === 'Active' || (item.status === 'New' && !dayOff.value);
  const isDayScheduleNotEmpty = !dayScheduleEmpty.value;

  if (isOfflineDirectorRole.value || isWFMReaderRole.value) {
    return false
  }

  if (isDone && positionCodeIsPicker.value) {
    return false
  }

  // Смена в прошлом месяце
  if (creatingMonth === previousMonthNumber) {
    return false
  }

  // 2 числа по дате текущего месяца запрещаем менять смены на последние числа прошлого месяца (для всех ролей)
  if (currentDay === 2 && creatingDay <= 31 && creatingMonth !== currentMonthNumber) {
    return false
  }

  return (
    !dayOff.value &&
    isNotMiss &&
    isNotCanceled &&
    isNotMissAccepted &&
    isNotExchange &&
    isNotProfiPst &&
    isPositionOrActiveOrNew &&
    isDayScheduleNotEmpty
  )
}

const onUpdateShiftClick = (item: TimeRange) => {
  const isNotUpdatingSameItem = updatingOpenId.value !== item.id

  // Закрываем меню действий у смены
  closeShiftMenu(item)

  if (canUpdateShift(item) && isNotUpdatingSameItem) {
    reachGoal('timetable-shift-edit')
    return openUpdatingItem(item)
  } else {
    return null
  }
}

// Проверка на возможность обновить смену в выбранный день
const isUpdateShiftAvailable = (item: TimeRange) => {
  return canUpdateShift(item)
}

// Является ли пользователь комплектовщиком
const positionCodeIsPicker = computed<boolean>(() => {
  return props.user.positionCode === 'Комплектовщик'
})

// Проверка, что ГУРВ может создавать смены в определённом диапазоне в прошлом
const canGurvEditPastShift = () => {
  const { creatingDay, creatingMonth, currentMonthNumber, previousMonthNumber, currentDay } =
    extractDatePartsGURV(props.date)

  if (isGurvRole.value) {
    if (!dayScheduleEmpty.value || positionCodeIsPicker.value) {
      // Создавать смены в прошлом месяце
      if (creatingMonth === previousMonthNumber) {
        return true
      }
      // ГУРВ может создавать смены с начала текущего месяца
      if (creatingMonth === currentMonthNumber && creatingDay <= currentDay) {
        return true
      }
    }
  }
}

// Проверка на возможность создать смену в выбранный день
const canCreateShift = () => {
  const { creatingDay, creatingMonth, currentMonthNumber, currentDay, previousMonthNumber } =
    extractDatePartsGURV(props.date)

  // ПрофиПСТ из другой аптеки: смены ему создаются только по месту трудоустройства
  if (isExternalProfiUser.value) {
    return false
  }

  // ПрофиПСТ из другой аптеки: смены ему создаются только по месту трудоустройства
  if (isExternalProfiUser.value) {
    return false
  }

  if (isOfflineDirectorRole.value || isWFMReaderRole.value) {
    return false
  }

  // Проверка у ГУРВ на пустой день для всех кроме Комплектовщиков
  if (isGurvRole.value) {
    // В выходной день запрещаем создание смен для всех кроме Комплектовщиков
    if (dayOff.value && !positionCodeIsPicker.value) {
      return false
    }

    if (
      (canGurvEditPastShift() && !dayScheduleEmpty.value) ||
      (canGurvEditPastShift() && positionCodeIsPicker.value && dayScheduleEmpty.value)
    ) {
      return true
    }
  }

  // С 17 числа по дате текущего месяца запрещаем менять смены 15 числа
  if (currentDay >= 17 && creatingDay === 15 && creatingMonth === currentMonthNumber) {
    return false
  }

  // 2 числа по дате текущего месяца запрещаем менять смены на последние числа прошлого месяца (для всех кроме ГУРВ)
  if (currentDay === 2 && creatingDay <= 31 && creatingMonth === previousMonthNumber) {
    newShift.value = false // Убираем пересчёт ФРВ
    return false
  }

  // Основная проверка
  if (
    (newShift.value && !dayOff.value && !dayScheduleEmpty.value) ||
    (positionCodeIsPicker.value && newShift.value)
  ) {
    return true
  }
}

// Проверка на возможность удалить смену в выбранный день
const isDeleteShiftAvailable = (item: TimeRange) => {
  const { creatingMonth, currentDay, creatingDay, previousMonthNumber } = extractDatePartsGURV(
    props.date,
  )

  // Запрещаем удалять смены БЕРУ и со статусом Miss
  if (item.type === 'Exchange' || item.status === 'Miss') {
    return false
  }

  // Запрещаем удалять смены с определёнными статусами (OMR-3385)
  if (item.status === 'Canceled' || item.status === 'MissAccepted') {
    return false
  }

  // Запрещаем удалять смены для группы OFFLINE_DIRECTOR
  if (isOfflineDirectorRole.value) {
    return false
  }

  // Условия для группы GURV
  if (isGurvRole.value) {
    const previousMonthDate = startOfMonth(addMonths(new Date(), -1)) // прошлый месяц
    const shiftStartDate = parse(item.dateFrom, 'd.M.yyyy', new Date()) // дата начала смены
    // Переходящие смены созданные в позапрошлом месяце
    if (differenceInCalendarMonths(shiftStartDate, previousMonthDate) < 0) {
      return false
    }

    // Остальные проверки для GURV
    if (
      canGurvEditPastShift() ||
      item.status === 'New' ||
      item.status === 'Active' ||
      item.status === 'Done'
    ) {
      return true
    }
  }

  // 2 числа по дате текущего месяца запрещаем менять смены на последние числа прошлого месяца (для всех кроме ГУРВ)
  if (currentDay === 2 && creatingDay <= 31 && creatingMonth === previousMonthNumber) {
    return false
  }

  // Для всех остальных смен со статусом New доступно удаление
  return item.status === 'New'
}

// Проверка на возможность копировать смену в выбранный день
const isCopyShiftAvailable = (item: TimeRange) => {
  return item.id
}

const onCopyShiftClick = (item: TimeRange) => {
  closeShiftMenu(item)
  shiftBuffer.value = {
    dateFrom: item.dateFrom,
    dateTo: item.dateTo,
    shiftStatus: 'New',
    shiftType: shiftType.value,
    tempId: uuid(),
    pharmId: pharmId.value,
    zupGuid: props.user.zupGuid,
    userId: props.user.id,
    timeFrom: item.timeFrom,
    timeTo: item.timeTo,
  }
  store.commit('copyShift', shiftBuffer.value)
  reachGoal('timetable-copy-shift')
}

const canOpenShiftMenu = (item: TimeRange) => {
  // Отключаем меню для группы OFFLINE_DIRECTOR, при активном редактировании смены, для смен с типом Беру
  if (isOfflineDirectorRole.value || updatingOpenId.value) return false;
  if (item.type === 'ProfiPst') return false;
  return item.type !== 'Exchange';
}

// Открытие меню действий у смены
const openShiftMenu = (item: TimeRange) => {
  if (menuOpenId.value === item.id) {
    closeShiftMenu(item)
  } else {
    menuOpenId.value = item.id
    reachGoal('timetable-shift-menu-open')
  }
}

// Закрытие меню действий у смены
const closeShiftMenu = (item: TimeRange) => {
  if (menuOpenId.value && menuOpenId.value === item.id) {
    menuOpenId.value = null
  }
}

const pasteShift = (date: string) => {
  // Проверяем на наличие скопированной смены
  if (!shiftBufferObj.value || Object.keys(shiftBufferObj.value).length === 0) {
    return false
  }

  // Если смена переходящая
  if (timeToSeconds(shiftBufferObj.value.timeTo) < timeToSeconds(shiftBufferObj.value.timeFrom)) {
    shifts.value.dateTo = addHours(
      parse(`${nextDay} ${shiftBufferObj.value.timeTo}`, 'd.M.yyyy HH:mm', new Date()),
      timezoneOffset.value,
    ).toISOString()
  } else {
    shifts.value.dateTo = addHours(
      parse(`${date} ${shiftBufferObj.value.timeTo}`, 'd.M.yyyy HH:mm', new Date()),
      timezoneOffset.value,
    ).toISOString()
  }

  shifts.value.dateFrom = addHours(
    parse(`${date} ${shiftBufferObj.value.timeFrom}`, 'd.M.yyyy HH:mm', new Date()),
    timezoneOffset.value,
  ).toISOString()

  addShift()
  reachGoal('timetable-paste-shift')
}

// Получение заголовка со временем скопированной смены
const pasteShiftTitle = computed(() => {
  if (shiftBufferObj.value?.timeFrom) {
    return `Скопировано ${shiftBufferObj.value.timeFrom} - ${shiftBufferObj.value.timeTo}`
  }
  return 'Смена не скопирована'
})

// Проверка на возможность просмотра информации о смене в выбранный день (только для ГУРВ и основных смен)
const isInfoShiftAvailable = (item: TimeRange) => {
  if (isGurvRole.value && item.type !== 'Partner' && item.type !== 'MainProfi') {
    return item.id
  }
}

const openShiftInfoModal = () => {
  shiftInfoModal.value.open = true
}

const closeShiftInfoModal = () => {
  shiftInfoModal.value.open = false
}

// Передаём ID смены в компонент показа информации
const shiftInfoId = ref('')

const onInfoShiftClick = (item: TimeRange) => {
  if (item.id) {
    shiftInfoId.value = item.id
    closeShiftMenu(item)
    openShiftInfoModal()
    reachGoal('timetable-shift-info')
  }
}

onBeforeMount(async () => {
  // Отменяем все действия при открытии для группы OFFLINE_DIRECTOR и WFM_READER, а также для нетрудоустроенных
  if (isOfflineDirectorRole.value || isWFMReaderRole.value || props.isUserInactive) {
    return false
  }

  if (canCreateShift() || newShift.value) {
    setValidInputTime()
    // noinspection ES6RedundantAwait
    await inputEvent()
  }

  if ((positionCodeIsPicker.value && dayOff.value) || (!dayOff.value && !props.hasVacation)) {
    // Если нет расписания на день (применяем ко всем, кроме комплектовщиков)
    if (dayScheduleEmpty.value && !positionCodeIsPicker.value) {
      timeShiftQuery.timeShift = 0
      timeShiftQuery.frvRv = 0
    }
    store.commit('data/saveMainFRV')
    store.commit('data/saveHumanFRV', props.user)
    store.commit('data/changeTimeShift', timeShiftQuery)
    store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)
  }
})
onBeforeUnmount(() => {
  // Отменяем все действия при открытии для группы OFFLINE_DIRECTOR и WFM_READER
  if (isOfflineDirectorRole.value || isWFMReaderRole.value) {
    return false
  }

  if (
    ((canCreateShift() || newShift.value) && positionCodeIsPicker.value && dayOff.value) ||
    (!dayOff.value && !props.hasVacation)
  ) {
    timeShiftQuery.timeShift = 0
    timeShiftQuery.frvRv = 0
    store.commit('data/changeTimeShift', timeShiftQuery)
    store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)
  }

  // Закрываем и отменяем обновление смены (OMR-4127)
  if (updatingOpenId.value) {
    timeShiftQuery.timeShift = 0
    timeShiftQuery.frvRv = 0
    store.commit('data/resetMainFRV')
    store.commit('data/resetHumanFRV', { user: props.user })
    store.commit('data/changeTimeShift', timeShiftQuery)
    store.commit('data/changeFRV_RVTimeShift', timeShiftQuery)
  }
})

// Проверяем, что дата в прошлом для вывода ошибки "Невозможно создать смену на прошедший день"
const dayIsPassed = computed<boolean>(() => {
  return addDays(new Date(), -3).getTime() > parse(props.date, 'd.M.yyyy', new Date()).getTime()
})

// Проверки для зарплатных дней (2 и 17 число) (OMR-3438)
const salaryDaysRestriction = computed(() => {
  const { creatingDay, creatingMonth, currentMonthNumber, previousMonthNumber, currentDay } =
    extractDatePartsGURV(props.date)
  // Не выводим ошибку у ГУРВ (OMR-3778)
  if (isGurvRole.value) return false

  // С 17 числа по дате текущего месяца запрещаем менять смены 15 числа (OMR-3438)
  if (currentDay >= 17 && creatingDay === 15 && creatingMonth === currentMonthNumber) {
    return true
  }

  // 2 числа по дате текущего месяца запрещаем менять смены на последние числа прошлого месяца (для всех кроме ГУРВ)
  if (currentDay === 2 && creatingDay <= 31 && creatingMonth === previousMonthNumber) {
    return true
  }

  return false
})

// Варианты ошибок при создании смены
// Невозможно создать смену на прошедший день
const pastDayError = computed(() => {
  if (salaryDaysRestriction.value) return true // Выводим ошибку в дни зарплат (OMR-3438)

  if (!dayIsPassed.value) return false

  // Не показываем ошибку при кадровом
  if (hasVacationOnDay(props.user, props.date)) {
    return false
  }

  if (isGurvRole.value && dayIsPassed.value && dayOff.value) {
    return false
  }

  if (isOfflineAdminRole.value && dayIsPassed.value) {
    return true
  }

  if (!dayScheduleEmpty.value || positionCodeIsPicker.value) {
    return true
  }

  return false
})

// Отсутствует расписание аптеки
const scheduleError = computed(() => {
  if (dayOff.value) return false

  // Не показываем ошибку при кадровом
  if (hasVacationOnDay(props.user, props.date)) {
    return false
  }

  if (!dayIsPassed.value && dayScheduleEmpty.value) {
    return true
  }

  if (!isOfflineAdminRole.value || !positionCodeIsPicker.value) {
    return true
  }

  return false
})

// Невозможно создать смену. В аптеке выходной день
const dayOffError = computed(() => {
  if (!dayOff.value) return false

  // Не показываем ошибку при кадровом
  if (hasVacationOnDay(props.user, props.date)) {
    return false
  }

  if (isGurvRole.value && dayIsPassed.value) {
    return true
  }

  if ((isOfflineAdminRole.value || isGurvRole.value) && !dayIsPassed.value) {
    return true
  }

  return false
})

const shiftsScrollList = ref<PerfectScrollbarExpose | null>(null)
const isScrollable = ref(false)

// Проверка на высоту блока со сменами заданную в CSS (OMR-3385)
const checkShiftsHeight = async () => {
  await nextTick()

  const el = shiftsScrollList.value?.ps?.element
  if (!el) return

  // Получаем высоту блока из CSS и при превышении включаем скролл (OMR-4523)
  const contentHeight = el.offsetHeight
  const computedStyle = window.getComputedStyle(el)
  const contentMaxHeight = parseInt(computedStyle.maxHeight, 10)

  if (contentHeight && !isNaN(contentMaxHeight)) {
    isScrollable.value = contentHeight >= contentMaxHeight
  }
}

onMounted(() => {
  checkShiftsHeight()
})

// В массиве только смены (OMR-3385)
const hasOnlyShifts = (arr: TimeRange[]) => {
  if (!arr) return false
  return arr.every((obj) => 'zupGuid' in obj)
}

// В массиве только отменённые смены (OMR-3385)
const hasOnlyMissedShifts = (arr: TimeRange[]) => {
  if (!arr || arr.length === 0) return false

  return arr.every((obj) => obj.status === 'MissAccepted' || obj.status === 'Canceled')
}

// Есть кадровые в текущем дне (OMR-3385)
const hasVacationOnDay = (user: NewUser, date: string) => {
  if (!user.timeShift || !user.timeShift[date]) return

  if (user.timeShift[date].length > 0 && !user.timeShift[date].every((obj) => 'zupGuid' in obj)) {
    return true
  }
}

// Показываем ли блок со сменами (OMR-3385)
const isShiftsVisible = (user: NewUser, date: string) => {
  // Добавлена проверка на наличие элементов с zupGuid (OMR-3926)
  if (
    !user.timeShift ||
    !user.timeShift[date] ||
    !user.timeShift[date].some((obj) => 'zupGuid' in obj)
  )
    return false

  // У ГУРВ отображаем отмененные смены
  if (isGurvRole.value && user.timeShift[date].length > 0) return true

  // У OFFLINE_USER и OFFLINE_DIRECTOR не отображаем отмененные смены
  if (
    (isOfflineDirectorRole.value || isOfflineAdminRole.value) &&
    hasOnlyMissedShifts(user.timeShift[date])
  )
    return false

  // В остальных случаях отображаем если смены есть
  return hasOnlyShifts(user.timeShift[date]) && user.timeShift[date].length > 0
}

const canCreateVacation = (user, date: string) => {
  if (!user || (!user.timeShift && !user.timeShift[date]) || !date) return false

  if (props.isUserInactive) return false

  // Не разрешаем проставить НН на днях с isAbsence
  const shiftItems = user.timeShift[date]
  if (Array.isArray(shiftItems) && shiftItems.some((item) => item.type === 'isAbsence')) {
    return false
  }

  const selectedDate = parse(date, 'd.M.yyyy', new Date())
  const normalizedDate = startOfDay(selectedDate)

  // Разрешаем для OFFLINE_DIRECTOR с ролью OFFLINE_ADMIN, а так же всем с OFFLINE_ADMIN и GURV (OMR-5603)
  const permittedRole =
    (isOfflineAdminRole.value && isOfflineDirectorRole.value) ||
    isGurvRole.value ||
    isOfflineAdminRole.value

  // Возможно проставить НН если пользователь не внешний, имеет необходимые права и дата сегодня или позднее
  return permittedRole && !user.externalUser && !isBefore(normalizedDate, startOfToday())
}

const openVacationEdit = () => {
  activeVacationChange.value = true
}

const closeVacationEdit = () => {
  activeVacationChange.value = false
  activeVacationUpdate.value = null
  openConfirmModal.value = false
}

// Текст отображаемый при наличии dateDismissal или dateOfEmployment
const inactiveReasonText = computed<string>(() => {
  const cellDate = startOfDay(parse(props.date, 'dd.MM.yyyy', new Date()))
  const { dateOfEmployment, dateDismissal } = props.user

  // Вывод строки с датой трудоустройства
  if (dateOfEmployment && isBefore(cellDate, new Date(dateOfEmployment))) {
    return `Трудоустройство с ${format(new Date(dateOfEmployment), 'dd.MM', { locale: ru })}`
  }

  // Вывод строки с датой увольнения
  if (dateDismissal) {
    const dismissalDate = new Date(dateDismissal)

    // Если указана дата увольнения, то выводим эту дату + 1 день
    if (!isBefore(cellDate, dismissalDate)) {
      return `Увольнение с ${format(addDays(dismissalDate, 1), 'dd.MM', { locale: ru })}`
    }
  }

  return ''
})

// Проверка на isAbsence в выбранном дне
const hasAbsenceOnDay = (user: NewUser, date: string) => {
  if (!user.timeShift || !user.timeShift[date]) return false

  const dayEntries = user.timeShift[date]

  if (!Array.isArray(dayEntries)) return false

  return dayEntries.flat().some((item) => item?.type === 'isAbsence')
}
</script>

<style scoped lang="scss">
@use '../static/style/variables.scss' as *;
@use '../static/style/mixins.scss' as *;

.shift {
  position: absolute;
  z-index: 999;
  top: 10px;
  box-shadow: -1px 0px 15px 0px #00000026;
  min-width: 366px;
  background: rgba(255, 255, 255, 1);

  &__error {
    color: $red;
    font-size: 10px;
    margin-top: 12px;

    &-secondary {
      padding: 5px;
      background: rgba(255, 255, 255, 1);
      border-radius: 6px;
      font-weight: 400;
      line-height: 12.19px;
    }
  }

  &__error-wrap {
    display: inline-block;

    &:not(:last-child) {
      padding-bottom: 12px;
      margin-bottom: 12px;
      border-bottom: 1px solid #cccccc;
    }

    .shift__error {
      margin-top: 0;
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 400;
      line-height: 12px;
    }
  }

  &__form {
    & + .shift__times {
      padding-top: 12px;
      margin-top: 12px;
      border-top: 1px solid #cccccc;
    }

    &-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: var(--spacing-12);

      .shift__title {
        margin-bottom: 0;
      }
    }
  }

  .shift__tri {
    width: 36px;
    height: 30px;
  }

  &.left {
    left: calc(100% + 20px);

    .shift__tri {
      left: -29px;
      transform: rotate(0);
    }
  }

  &.right {
    right: calc(100% + 20px);

    .shift__tri {
      right: -29px;
      transform: rotate(180deg);
    }
  }

  &.center {
    top: 10px;
    transform: translateY(-50%);

    .shift__tri {
      top: 60%;
    }
  }

  &.bottom {
    top: auto;
    bottom: 10px;

    .shift__tri {
      bottom: 42px;
    }
  }

  &.top {
    bottom: auto;
    top: 10px;

    .shift__tri {
      top: 42px;
    }
  }

  &__tri {
    position: absolute;
    z-index: 1;
  }

  &__head {
    background: #dddddd;
    @include font_2;
    padding: 12px 24px;
    border-radius: 3px 3px 0 0;

    .icon {
      fill: #888;
      position: absolute;
      right: 23px;
      top: 12px;
      cursor: pointer;
    }
  }

  &__title {
    @include font_2;
    margin-bottom: 12px;
  }

  &__link {
    font-family: var(--global-font-family), sans-serif;
    -webkit-appearance: none;
    appearance: none;
    background: transparent;
    border: unset;
    display: inline-flex;
    gap: 6px;
    font-weight: 500;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0;
    cursor: pointer;
    color: var(--text-color-blue);
    transition: opacity 0.15s;

    &:hover {
      opacity: 0.8;
    }
  }

  &__content {
    padding: 12px 24px 24px;
    background: $white;
    border-radius: 0 0 3px 3px;
    position: relative;
    z-index: 999;
    min-height: 63px;

    &:has(.shift__times) .shift__error-wrap {
      padding-bottom: 12px;
      margin-bottom: 12px;
      border-bottom: 1px solid #cccccc;
    }

    &:has(.shift__error-wrap) .shift__times {
      border-top: unset;
      padding-top: 0;
      margin-top: 0;
    }

    &:has(.shift__times) .shift__vacation-title {
      margin-bottom: 24px;
    }

    &:has(.shift__form-head) .shift__vacation-add {
      position: absolute;
      top: 12px;
      right: 24px;
      margin-top: 0;
      padding-top: 0;
      border: unset;
    }

    &:has(.shift__error-wrap) .shift__vacation-add {
      border: unset;
      padding: 0;
      margin-top: 0;
    }
  }

  .shift__error-secondary {
    font-weight: 500;
    font-size: 15px;
    line-height: 1.1;
    letter-spacing: 0%;
    vertical-align: middle;
    color: #333333;
  }

  &__inputs {
    display: flex;
    align-items: center;

    .input-box {
      margin-bottom: 0;
      margin-right: 10px;
      height: 34px;

      &.active {
        border: 1px solid #30a8ff;
        box-shadow: 0 0 0 2px #cbe9ff;
      }
    }

    & + .shift__times-break {
      margin-top: 6px;
    }

    .btn + .btn {
      margin-left: 8px;
    }
  }

  &__times {
    border-top: 1px solid #cccccc;
    padding-top: var(--spacing-12);
    margin-top: var(--spacing-12);

    .icon {
      margin-right: 13px;
    }

    .close {
      cursor: pointer;

      svg {
        fill: $red !important;

        path {
          fill: $red !important;
        }
      }
    }

    &-date {
      display: flex;
      align-items: center;
      margin-bottom: 6px;

      span {
        color: rgba(136, 136, 136, 1) !important;
      }

      svg {
        margin: 0 5px;
      }
    }

    &-time {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &:not(:last-child) {
        margin-bottom: 6px;
      }

      .time {
        display: flex;
        align-items: center;
      }
    }

    &-break {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 15px;
      line-height: 100%;
      letter-spacing: 0;

      > div:last-child {
        margin-left: 12px;
      }

      .icon {
        margin-right: 13px;
      }

      &:not(:last-child) {
        margin-bottom: 6px;
      }
    }
  }
}

.time-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1 0 auto;
  position: relative;

  &:not(.update-active) {
    cursor: pointer;
  }

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -4px;
    right: -13px;
    min-height: 30px;
    background: rgba(255, 255, 255, 0.6);
    height: 100%;
    border-radius: 6px;
    opacity: 0;
    transition: opacity 0.15s ease;
    pointer-events: none;
  }

  &.update-active::before {
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    right: -33px;
  }

  &:hover::before {
    opacity: 1;
  }
}

.update-active-span {
  margin-right: 5px;
}

.shift__times-time > div:first-child {
  display: flex;
}

.shift__times-time-inner {
  flex: 1 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  gap: 8px;

  .close {
    min-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btn-success,
  .time,
  .close {
    position: relative;
    z-index: 2;
  }

  .time span {
    border: 2px solid transparent;
  }

  .input-box {
    margin: 0;
    height: 22px;
    box-shadow: unset;
    border-radius: 3px;
    border-color: transparent;
    width: auto;

    input {
      border-radius: 3px;
      border: 1px solid transparent;

      &:hover {
        border-color: rgba(48, 168, 255, 1);
      }
    }
  }
}

.shift__times-miss,
.shift__times-done,
.shift__times-dayoff,
.shift__times-exchange,
.shift__times-default {
  .time-wrapper {
    cursor: initial;
  }
  .time-wrapper::before {
    opacity: 0;
  }
}

.editing-fields {
  display: flex;
  align-items: center;
}

.shift__times-item-controls > div {
  display: flex;
  align-items: center;
  gap: 9px;

  .close {
    width: 20px;
    height: 20px;
  }
}

.shift__times-item {
  box-sizing: border-box;
  padding: 8px;
  gap: 6px;
  border-radius: 6px;
  min-height: 36px;

  span {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 1.33;
    color: #333333;
    border-top: unset !important;
    border-bottom: unset !important;
  }

  .time .icon {
    margin-right: 13px;
  }

  .time .icon-arrow {
    margin: 0 3px;
  }
}

.shift__times-done {
  background: rgba(148, 156, 175, 0.2);
}

.shift__times-new {
  background: rgba(95, 152, 236, 0.2);
}

.shift__times-active {
  background: rgba(104, 205, 187, 0.2);
}

.shift__times-miss {
  background: rgba(255, 140, 93, 0.2);
}

.shift__times-canceled {
  background: rgba(253, 96, 87, 0.2);
}

.shift__times-missaccepted {
  background: rgba(253, 96, 87, 0.2);
}

.shift__times-hidden.shift__times-canceled,
.shift__times-hidden.shift__times-missaccepted {
  display: none;
}

.button {
  min-width: 30px;
  border: 0;
  height: 24px;
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 3px;
  width: 100%;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.85;
  }

  &:active {
    opacity: 1;
  }

  &.disabled,
  &[disabled] {
    pointer-events: none;
    background: #888;
    color: rgba(136, 136, 136, 1);
  }
}

.btn-success {
  background: rgba(48, 182, 72, 1);
  color: #fff;
}

.btn-danger {
  background: rgba(255, 59, 48, 1);
  color: rgba(255, 255, 255, 1);
}

.btn-success,
.btn-danger {
  &[disabled] {
    color: #ffffff;
  }
}

.btn-toggle {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(204, 204, 204, 0.5);
  border-radius: 6px;
  height: 20px;

  span {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    color: #333333;
  }
}

.btn-toggle-open svg {
  transform: rotate(180deg);
}

.shift-miss-layout {
  background: #ffffff;
  border-radius: 6px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 6px;

  .button {
    font-size: 12px;
  }
}

.shift-miss-layout-inner {
  display: flex;
  flex-direction: column;
  gap: 8px;

  > div > :first-child {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    color: #999999;
  }

  > div > :last-child {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    color: #333333;
    margin-top: 2px;
    max-width: 300px;
    word-break: break-word;
    max-height: 62px;
  }
}

.shift-miss-layout-comment {
  padding-right: 8px;
}

.input-readonly input {
  background: transparent;
}

.shift__menu {
  position: relative;
}

.shift__menu-icon {
  display: flex;
  cursor: pointer;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.7;
  }
}

.shift__times-wrap {
  --scroll-threshold: 209px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: var(--scroll-threshold);
  border-radius: 6px;
  margin-right: -24px;
  margin-left: -24px;
  padding-left: 24px;
  padding-right: 24px;
  margin-bottom: -24px;
  padding-bottom: 24px;

  > div {
    flex: 1 0 auto;
  }

  > div.shift__times-missaccepted,
  > div.shift__times-canceled {
    order: 9999;
  }
}

.not-shift {
  display: none;
}

.shift__vacation-row {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-12);
}

.shift__vacation-title {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-12);
}

.shift__content-buttons {
  display: flex;
  gap: 8px;
  margin-top: var(--spacing-12);

  .btn + .btn {
    margin-left: 0;
  }
}

.shift__vacation-item {
  display: block;

  &:not(:first-child) {
    padding-top: var(--spacing-12);
    border-top: 1px solid rgba(204, 204, 204, 1);
  }

  &[hidden] {
    display: none;
  }
}

.shift__vacation-add {
  &:not(:first-child) {
    margin-top: var(--spacing-12);
    padding-top: var(--spacing-12);
    border-top: 1px solid rgba(204, 204, 204, 1);
  }
}
</style>
